import { useState, useEffect } from 'react';

const useImagePreload = (imageUrls) => {
    const [imagesLoaded, setImagesLoaded] = useState(false);

    useEffect(() => {
        const loadImage = (src) => {
            return new Promise((resolve, reject) => {
                const img = new Image();
                img.src = src;
                img.onload = resolve;
                img.onerror = reject;
            });
        };

        Promise.all(imageUrls.map(loadImage))
            .then(() => setImagesLoaded(true))
            .catch(error => console.error('Error loading images:', error));
    }, [imageUrls]);

    return imagesLoaded;
};

export default useImagePreload; 